<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <OpexFormulario :idTipoOpex="idTipoOpex" :tipoOpex="tipoOpex" :nombreTipoOpex="nombreTipoOpex">
          </OpexFormulario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexPackingFormNuevo',
  components: {
    OpexFormulario: () => import('../../components/OpexFormulario')
  },
  data: () => ({
    title: 'REGISTRO OPEX PACKING',
    page: {
      title: 'Registro OPEX Packing'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX Packing',
        disabled: true
      },
      {
        text: 'Registro',
        disabled: false
      }
    ],
    idTipoOpex: 2,
    tipoOpex: 'pack',
    nombreTipoOpex: 'Packing'
  }),
  methods: {
    open() {},
    close() {}
  },
  created() {}
};
</script>
